var map = {
	"./icon-arrow-breadcrumb.svg": "3c54",
	"./icon-arrow-medium.svg": "45cc",
	"./icon-arrow-slider.svg": "2ae7",
	"./icon-arrow-small.svg": "c610",
	"./icon-arrow-wide-down.svg": "d953",
	"./icon-basket-fill.svg": "8c55",
	"./icon-basket.svg": "5c1d",
	"./icon-bolia-logo-simple.svg": "3cfd",
	"./icon-bolia-logo-tagline.svg": "76c3",
	"./icon-bolia-logo.svg": "be56",
	"./icon-burger.svg": "f1dd",
	"./icon-checkmark-medium.svg": "655f",
	"./icon-checkmark.svg": "50b6",
	"./icon-close-round.svg": "bf40",
	"./icon-co2e.svg": "a863",
	"./icon-copy.svg": "3819",
	"./icon-delivery.svg": "4f85",
	"./icon-download.svg": "ae39",
	"./icon-edit.svg": "d5ef",
	"./icon-empty-basket.svg": "1ffe",
	"./icon-eye-line.svg": "1cf0",
	"./icon-eye.svg": "7615",
	"./icon-gift.svg": "694b",
	"./icon-heart-fill.svg": "de3c",
	"./icon-heart.svg": "1a8b",
	"./icon-load-basket.svg": "87a0",
	"./icon-map.svg": "56df",
	"./icon-minus-medium.svg": "7206",
	"./icon-minus.svg": "a866",
	"./icon-my-bolia.svg": "c9be",
	"./icon-new-offer.svg": "9813",
	"./icon-pdf.svg": "179a",
	"./icon-play.svg": "1960",
	"./icon-plus-medium.svg": "7ef6",
	"./icon-plus-small.svg": "e418",
	"./icon-plus.svg": "a3b7",
	"./icon-return-item.svg": "3406",
	"./icon-save-basket.svg": "cae5",
	"./icon-scroll-to-top.svg": "92fa",
	"./icon-search.svg": "6819",
	"./icon-some-link.svg": "4ca5",
	"./icon-some-mail.svg": "cb03",
	"./icon-some-messenger.svg": "216c",
	"./icon-some-pinterest.svg": "3571",
	"./icon-trash-bin.svg": "032c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "6f32";